import { useContext } from 'react'
import { UneeqContext } from 'uneeq-react-core'

export const useUneeqContext = () => useContext(UneeqContext)
